angular.module('EdxTeacherReportModule')
  .controller('EdxTeacherReportController', [
    '$scope',
    '$state',
    'edxStateParamsService',
    'teacherApi',
    'timeframe',
    function (
      $scope,
      $state,
      edxStateParamsService,
      teacherApi,
      timeframe) {

      var params = _.pick($state.params, ['districtId']);
      params.teacher_id = $state.params.teacherId;
      params = _.extend(params, edxStateParamsService.getTimeframeParamsForEarlyHighlights());

      teacherApi.getTeacherHighlights(params).then(function (teacherData) {
         timeframe.getYearListSubject().onNext(teacherData.years);

         // deprecated: use timeframe.getYearListSubject instead of broadcast
         $scope.$broadcast('updateYears', teacherData.years);

         return teacherData;
      });
    }
  ]);
